<template>
  <div class="wh100 select-point">
    <div class="select-point-map">
      <div id="selectpointMap" class="wh100"></div>
    </div>
  </div>
</template>
<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
// import "../../commonJs/map/leaflet.ChineseTmsProviders";
// import "../../commonJs/map/leaflet.mapCorrection.min.js"
// import geojson from "../../../public/geoJson.json"
export default {
  components: {},
  props: {
    lon: {
      type: String,
      default: "",
    },
    lat: {
      type: String,
      default: "",
    },
    Status:{
      type:Number,
      default:1,
    }
  },
  data() {
    return {
      geoStyleShow: {
        color: "#01A8FF",
        weight: 2,
        fill: true,
        fillColor: "#01A8FF",
        fillOpacity: 0.1,
        opacity: 0.4,
      },
      townBoundary:null,
      map: null,
      form: {
        lon: "",
        lat: "",
      },
      marker: null,
      markers:[],
    };
  },
  methods: {
    initMap() {
      let that = this;
      let normalm = L.tileLayer.chinaProvider("TianDiTu.Normal.Map", {
        key: "6717a1d5490fc88dba7b1765b5cb388d",
        maxZoom: 18,
        minZoom: 5,
      });
      let normala = L.tileLayer.chinaProvider("TianDiTu.Normal.Annotion", {
        key: "6717a1d5490fc88dba7b1765b5cb388d",
        maxZoom: 18,
        minZoom: 5,
      });
      let imgm = L.tileLayer.chinaProvider("TianDiTu.Satellite.Map", {
        key: "6717a1d5490fc88dba7b1765b5cb388d",
        maxZoom: 18,
        minZoom: 5,
      });
      let imga = L.tileLayer.chinaProvider("TianDiTu.Satellite.Annotion", {
        key: "6717a1d5490fc88dba7b1765b5cb388d",
        maxZoom: 18,
        minZoom: 5,
      });
      let gaode = L.tileLayer(
          "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}"
      );
      let normal = L.layerGroup([normalm, normala]);
      let image = L.layerGroup([imgm, imga]);

      let baseLayers = {
        标准: normal,
        影像: image,
      };

      let overlayLayers = {};
      let mapCenterLon= this.$store.state.loginInfo.centerLon;
      let mapCenterLat= this.$store.state.loginInfo.centerLat;
      let MapCenter = _myconfig.mapCenter;
      if (mapCenterLon && mapCenterLat) {
        MapCenter=[Number(mapCenterLat),Number(mapCenterLon)];
      }
      let map = L.map("selectpointMap", {
        layers: [gaode],
        minZoom: 3,
        maxZoom: 18,
        center: MapCenter,//_myconfig.mapCenter,
        zoom: 8,
        zoomControl: false,
        attributionControl: false,
      });
      this.map = map;
      L.control
          .zoom({
            zoomInTitle: "放大",
            zoomOutTitle: "缩小",
          })
          .addTo(map);
      L.control.layers(baseLayers, overlayLayers).addTo(map);
      if (this.lon && this.lat) {
        that.form.lon = that.lon;
        that.form.lat = that.lat;
        that.map.panTo([that.lat, that.lon]);
        that.createMarker(this.lon, this.lat);
      }
    },
    createMarker(lon, lat) {
      let that = this;
      let myIcon = L.icon({
        iconUrl: require("@/assets/map/marker.png"),
        iconSize: [32, 32],
        iconAnchor: [16, 32],
      });
      if (lon && lat) {
        lat = Number(lat);
        lon = Number(lon);
        this.$nextTick(function () {
          let marker = L.marker([lat, lon], {
            icon: myIcon,
          });
          that.marker=marker;
          if (!that.markers) {
            that.markers = [];
          }
          that.markers.push(marker);
          marker.addTo(that.map);
          that.map.flyTo([lat, lon],8);
        })
      }
    },
    clear() {
      this.form.lon = "";
      this.form.lat = "";
      this.clearMaker();
      this.marker = null;
    },
    clearMaker() {
      let _this = this;
      if (_this.markers != null) {
        _this.markers.forEach((marker) => {
          _this.map.removeLayer(marker);
        });
        _this.markers = null;
      }
    },
  },
  mounted() {
    this.initMap();
  },

  watch: {
    lon: {
      immediate: true,
      handler: function () {
        this.form.lon = this.lon;
      },
    },
    lat:{
      immediate: true,
      handler: function () {
        this.clear();
        this.form.lat = this.lat;
        this.form.lon = this.lon;
        this.createMarker(this.lon,this.lat);
      },
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-form-item {
  margin-bottom: 0;
}
.select-point {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  // background: @grayback;
}
.filter {
  height: 50px;
  width: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 15px;
}
.select-point-map {
  height: calc(100% - 5px);
  width: 100%;
  box-sizing: border-box;
  // border-top: 2px solid @basecolor;
}
</style>